import { apiAsync } from '../../../common/helpers'

const fetchLocation = async (locationId) => apiAsync({
  method: 'GET',
  api: `locations/${locationId}/details`
})

export default { fetchLocation }
